module.exports = __webpack_public_path__ + "media/2-2.4493c4a4.wav";